import React, { useEffect, useState } from 'react'
import closeIcon from "../../Assets/Svg/close-icon.svg";
import "./TimestampCycle.css";
import "./ActivityPopup.css"
import TimestampCard from './TimestampCard';
import { getVendorEditCycleDataByIdAction } from '../../Store/actions/vendorMangementAction';
import { useDispatch } from 'react-redux';
import { transformTimeStampData } from '../../Utils/Utils';

const TimeStampCycle = ({id, closeModal, vendorId=null, totalDays}) => {
    const dispatch = useDispatch()
    const [data, setData] = useState([])

    useEffect(() => {
    if (id && vendorId) {
      dispatch(getVendorEditCycleDataByIdAction(id, vendorId)).then((res) => {
        if (res?.status === 200) {
          setData(transformTimeStampData(res?.data?.data?.approvalCycleData));
        }
      });
    }
  }, [id]);

  return (
    <>
     <div className="ac-title-close-icon-div">
          <p className="ac-title pb-2">Timestamp</p>
          <img
            src={closeIcon}
            alt=""
            onClick={closeModal}
            style={{ cursor: "pointer" }}
            id="closeIcon"
          />
        </div>
        <div className="ac-title-close-icon-div">
          <h3 style={{fontSize:"24px"}} className="ac-title pb-2">Edit Data</h3>
          <div className="AcitvityTimeContainer">
                <h2 className="AcitvityContentTime" style={{ color: "black" }}>
                  Total :
                </h2>{" "}
                <h2 className="AcitvityContentTime">{totalDays}</h2>
              </div>
        </div>
         <div className="ac-main-scroll pt-4">
            {
                data?.map((item, index)=>(
                    <TimestampCard key={index} e={item} index={index}/>
                ))
            }
         </div>
    </>
  )
}

export default TimeStampCycle